/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyOrdersPageInfoDtoBase
 * auto generated base class for the model ShopifyOrdersPageInfoDtoModel.
 */
export const ShopifyOrdersPageInfoDtoModelBase = ModelBase
  .named('ShopifyOrdersPageInfoDto')
  .props({
    __typename: types.optional(types.literal("ShopifyOrdersPageInfoDto"), "ShopifyOrdersPageInfoDto"),
    hasNextPage: types.union(types.undefined, types.boolean),
    endCursor: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyOrdersPageInfoDtoModelSelector extends QueryBuilder {
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  get endCursor() { return this.__attr(`endCursor`) }
}
export function selectFromShopifyOrdersPageInfoDto() {
  return new ShopifyOrdersPageInfoDtoModelSelector()
}

export const shopifyOrdersPageInfoDtoModelPrimitives = selectFromShopifyOrdersPageInfoDto().hasNextPage.endCursor
